import React, { useState, useEffect, useRef } from 'react';
import './CountUp.css';

function CountUp({ endNumber, duration = 2000, prefix = '+', locale = 'pt-BR' }) {
  const [count, setCount] = useState(0);
  const startTime = useRef(null);
  const end = useRef(endNumber);
  const durationMs = useRef(duration);

  // Função de easing (easeOutCubic)
  const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

  useEffect(() => {
    const start = performance.now();
    startTime.current = start;

    const update = (timestamp) => {
      if (!startTime.current) startTime.current = timestamp;
      const progress = (timestamp - startTime.current) / durationMs.current;
      const easedProgress = easeOutCubic(Math.min(progress, 1));

      const newCount = Math.floor(easedProgress * end.current);
      setCount(newCount);

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        setCount(end.current);
      }
    };

    requestAnimationFrame(update);
    return () => cancelAnimationFrame(update);
  }, [endNumber, duration]);

  return (
    <span className="count-up">
      {prefix}
      {count.toLocaleString(locale)}
    </span>
  );
}

export default CountUp;
